const initialState = {
  buildingPermit: {
    addDesignProConfirmOpen: false,
    projectConfirmModalOpen: false,
    feeSimpleConfirmModalOpen: false,
    bondingConfirmModalOpen: false,
    mortgageConfirmModalOpen: false,
    termiteConfirmModalOpen: false,
    privateProviderConfirmModalOpen: false,
  },
};

const modalControlStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BUILDING_PERMIT_MODALS":
      return {
        ...state,
        buildingPermit: {
          ...state.buildingPermit,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default modalControlStateReducer;
